import { memo, useEffect, useRef, } from 'react';
import { createChart, CrosshairMode } from 'lightweight-charts';
import { convertToDate } from '../../utils/global_functions';
import moment from 'moment';
import { calculateMovingAverageSeriesData } from '../../controllers/analysis';
import { CHART_OPEN_MODE } from '../../utils/global_variables';
import { useSelector } from 'react-redux';

const AreaChart = (props) => {
    const { lineData = [], isMa = null, isExpand, mode = CHART_OPEN_MODE.OVERVIEW, halfHeight } = props;
    const chartContainerRef = useRef();
    const chart = useRef();
    const isSideExpanded = useSelector(state => state.marketOverview.isSideExpanded);
    useEffect(() => {
        if (lineData?.length > 0) {

            if (chart.current) {
                chart.current.remove();
            }
            let tooltipElement = document.getElementById('tooltip');
            if (tooltipElement != null) {
                chartContainerRef.current.removeChild(tooltipElement);
            }
            chart.current = createChart(chartContainerRef.current, {
                crosshair: {
                    mode: CrosshairMode.Normal,
                },
            });
            chart.current.applyOptions({ timeScale: { timeVisible: true } });
            const ohlcAreaSeries = chart.current.addAreaSeries({
                lineColor: '#2962FF',
                topColor: 'rgba(41,98,255,0.28)',
                bottomColor: 'rgba(41,98,255,0.28)'
            });
            ohlcAreaSeries.setData(lineData);

            const histogramSeries = chart.current.addHistogramSeries({ priceFormat: { type: 'volume' }, priceScaleId: '' });
            histogramSeries.setData(lineData.map(x => { return { time: x?.time, value: x?.volume || 0 }; }));
            histogramSeries?.priceScale()?.applyOptions({ scaleMargins: { top: 0.8, bottom: 0 } });



            const toolTipWidth = 80;
            const toolTipHeight = 80;
            const toolTipMargin = 15;

            // Create and style the tooltip html element
            const toolTip = document.createElement('div');
            toolTip.id = 'tooltip';
            toolTip.style = `width: 96px; height: 80px; position: absolute; display: none; padding: 8px; box-sizing: border-box; font-size: 12px; text-align: left; z-index: 1000; top: 12px; left: 12px; pointer-events: none; border: 1px solid; border-radius: 2px;font-family: -apple-system, BlinkMacSystemFont, 'Trebuchet MS', Roboto, Ubuntu, sans-serif; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale;`;
            toolTip.style.background = 'white';
            toolTip.style.color = 'black';
            toolTip.style.borderColor = 'rgba( 38, 166, 154, 1)';
            chartContainerRef.current.appendChild(toolTip);

            // update tooltip
            chart.current.subscribeCrosshairMove(param => {
                if (
                    param.point === undefined ||
                    !param.time ||
                    param.point.x < 0 ||
                    param.point.x > chartContainerRef.current.clientWidth ||
                    param.point.y < 0 ||
                    param.point.y > chartContainerRef.current.clientHeight
                ) {
                    toolTip.style.display = 'none';
                } else {
                    // time will be in the same format that we supplied to setData.
                    // thus it will be YYYY-MM-DD
                    const dateStr = param.time;
                    toolTip.style.display = 'block';
                    const data = param.seriesData.get(ohlcAreaSeries);
                    const price = data.value !== undefined ? data.value : data.close;
                    toolTip.innerHTML = `<div style="font-size: 24px; margin: 4px 0px; color: ${'black'}">
                        ${Math.round(100 * price) / 100}
                        </div><div style="color: ${'black'}; text-align: ${'center'}">
                        ${moment(dateStr, 'YYYY-MM-DD').isValid() ? moment(dateStr, "YYYY-MM-DD").format(`DD MMM 'YY`) : convertToDate(dateStr, 'hh:mm a')}
                        </div>`;

                    const y = param.point.y;
                    let left = param.point.x + toolTipMargin;
                    if (left > chartContainerRef.current.clientWidth - toolTipWidth) {
                        left = param.point.x - toolTipMargin - toolTipWidth;
                    }

                    let top = y + toolTipMargin;
                    if (top > chartContainerRef.current.clientHeight - toolTipHeight) {
                        top = y - toolTipHeight - toolTipMargin;
                    }
                    toolTip.style.left = left + 'px';
                    toolTip.style.top = top + 'px';
                }
            });




            if (isMa) {

                const maData = calculateMovingAverageSeriesData(lineData, isMa);

                const maSeries = chart.current.addLineSeries({ color: '#f76f26', lineWidth: 1 });
                maSeries.setData(maData);
            }

            chart.current.timeScale().fitContent();
        }
    }, [isMa, lineData, isExpand, isSideExpanded]);

    return (
        <div className={mode === CHART_OPEN_MODE.OVERVIEW ? 'scripoverview-chart-wrapper' : halfHeight ? 'sidetray-chart-wrapper side-overview-chart-halfheight' : 'sidetray-chart-wrapper'}>
            <div ref={chartContainerRef} className={mode === CHART_OPEN_MODE.OVERVIEW ? 'scripoverview-chart' : 'sidetray-chart'} />
        </div>
    );
};

export default memo(AreaChart);